import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#07A7E3',
        },
        secondary: {
            main: '#FE9900',
        },
        transparent: {
            main: 'rgba(0,0,0,0)',
        },
    },
});
